import { Toaster as Sonner } from "sonner";

import { useThemeMode } from "@/lib/theme";

type ToasterProps = React.ComponentProps<typeof Sonner>;

/**
 * Global toast surface. Mounted once in AppShell; call `toast(...)` from
 * anywhere (import { toast } from "sonner"). Passes the page's light/dark
 * mode — read off `<html>`, wherever it was chosen — to sonner; the palette
 * is irrelevant here since the toast surfaces are styled
 * with token classes (`!bg-card`, …) that resolve per palette automatically.
 */
export function Toaster(props: ToasterProps) {
  const mode = useThemeMode();

  return (
    <Sonner
      theme={mode}
      className="toaster group"
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast:
            "group toast !bg-card !text-foreground !border !border-border !shadow-raised",
          description: "!text-muted-foreground",
          actionButton: "!bg-primary !text-primary-foreground",
          cancelButton: "!bg-surface-elevated !text-muted-foreground",
        },
      }}
      {...props}
    />
  );
}

export { toast } from "sonner";
